<template>
  <div v-if="retailerId === 'SOF'" class="wrapper">
    <div class="box box--no-v-padding text text--align-center">
      <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
        <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
        <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
      </svg>
      <div class="text text--big text--bold">We hope you love your brand new furniture</div>
    </div>
    <hr />
    <div class="box box--no-v-padding text text--align-center">
      <div class="text">Need to talk to us? Call us on <a href="tel:03444 81 81 81">03444 81 81 81</a></div>
    </div>
  </div>

  <div v-else class="wrapper">
    <div class="box box--no-v-padding text text--align-center text--big-lineheight">
      <i class="fas fa-check-circle" style="font-size: 48px"></i>
      <div class="text text--big">Delivered</div>
      <div class="text text--big text--bold">{{ arrivalTime }}</div>
    </div>
    <hr />
    <div class="box box--no-v-padding text text--align-center text--big-lineheight  ">
      <div class="text text--big">We hope you enjoy your new furniture</div>
      <div class="text">If for any reason you are unhappy with your delivery or your furniture, we can put it right.</div>
      <div class="text">Please call your local store in the first instance to discuss the issue.</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DeliveryComplete",
  props: ['retailerId', 'arrivalTime']
}
</script>
<style lang="scss">
  .checkmark {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: block;
    stroke-width: 3;
    stroke: #3f3f3f;
    stroke-miterlimit: 10;
    margin: 20px auto;
    box-shadow: inset 0px 0px 0px #3f3f3f;
    animation: scale .3s ease-in-out .9s both;
    &__circle {
      stroke-dasharray: 166;
      stroke-dashoffset: 166;
      stroke-width: 3;
      stroke-miterlimit: 10;
      stroke: #3f3f3f;
      fill: none;
      animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
    }
    &__check {
      transform-origin: 50% 50%;
      stroke-dasharray: 48;
      stroke-dashoffset: 48;
      animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
    }
  }
  @keyframes stroke {
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes scale {
    0%, 100% {
      transform: none;
    }
    50% {
      transform: scale3d(1.1, 1.1, 1);
    }
  }
</style>
